import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    RESET_PASSWORD,
    resetPasswordFail,
    resetPasswordSuccess
} from '../action/resetPasswordAction'

// api 
import resetPasswordApi from '../api/resetPasswordApi'

export function* resetPasswordSaga(action) {
    try {
        const response = yield call(() => resetPasswordApi(action.params))
        if (response.data.status === 1) {
            yield put(resetPasswordSuccess(response, action))
        } else {
            yield put(resetPasswordFail(response, action))
        }
    }
    catch (e) {
        yield put(resetPasswordFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(RESET_PASSWORD, resetPasswordSaga)
}